var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative subtitle-holder z-10 mb-4"},[_c('h2',{staticClass:"z-10 bg-white inline-block px-4 text-sm mr-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }